// extracted by mini-css-extract-plugin
export default {"examples":"responsiveStyles_examples__ANfNv","examplesInner":"responsiveStyles_examplesInner__ZmdJM","exampleImages":"responsiveStyles_exampleImages__XOkvG"};